import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

function SkeletonTableLoading({ columns, rows = 10 }) {
    return (
        <div className="table-responsive scrollbar ms-n1 ps-1">
            <table className="table table-sm fs-9 mb-0">
                <thead>
                <tr>
                    {columns.map((col, i) => (
                        <th key={i}>
                            <Skeleton height={14} width={`${50 + Math.random() * 70}%`} />
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {Array.from({ length: rows }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                        {columns.map((_, colIndex) => (
                            <td key={colIndex}>
                                <Skeleton height={14} width={`${70 + Math.random() * 30}%`} />
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

export default SkeletonTableLoading;
